<template>
    <div
        class="popup-share-mask"
        v-if="popShow"
        @click="hideShare(false)"
        :class="{ fadeIn: fadeIn }"
    >
        <div class="popup-share" :class="{ fadeIn: fadeIn }">
            <p>{{ $t('base.share_img') }}</p>
            <ul class="sns-list">
                <li class="sns-btn sns-fb" @click.stop="handleShare('fb')"></li>
                <li class="sns-btn sns-vk" @click.stop="handleShare('vk')"></li>
                <li class="sns-btn sns-wp" @click.stop="handleShare('wp')"></li>
            </ul>
            <div class="btn-cancel" @click="hideShare(true)">
                {{ $t('base.cancel_btn') }}
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
import { urlParser } from '@/utils';
import { shareConfig } from '@/config';
import Base64 from '@/utils/base64js.min.js';

export default {
    name: 'popup-share',
    data() {
        return {
            fadeIn: false
        };
    },
    computed: {
        popShow() {
            return this.$store.state.popup.share;
        }
    },
    methods: {
        ...mapMutations(['HIDE_POPUP', 'PLAY_SOUND', 'STOP_SOUND']),
        ...mapActions(['saveShare']),
        hideShare(playSound) {
            playSound && this.PLAY_SOUND('button');
            this.HIDE_POPUP('share');
        },
        handleShare(channel) {
            this.PLAY_SOUND('button');
            this.$LOG.send_click_share(channel);
            const { userinfo, lang } = this.$store.state;
            if (userinfo) {
                const { id, dragon_id, user_name } = userinfo;
                const encode_name = Base64.encode(user_name);
                const myurl = urlParser(location.href);
                myurl.data('code', null);
                myurl.data('channel', null);
                myurl.data('userid', id);
                myurl.data('dragonid', dragon_id);
                myurl.data('username', encode_name);
                const shareLink = myurl.url();
                const shareImg = shareConfig.img;
                const shareTitle =
                    lang == 'en'
                        ? shareConfig.title_en[2]
                        : shareConfig.title_ru[2];
                const shareDesc =
                    lang == 'en'
                        ? shareConfig.desc_en[1]
                        : shareConfig.desc_ru[1];
                this.saveShare({
                    channel,
                    code: 'abc',
                    url: shareLink,
                    title: shareTitle,
                    img: shareImg,
                    desc: shareDesc
                });
                console.log(shareLink);
                switch (channel) {
                    case 'fb':
                        window.open(
                            'https://m.facebook.com/sharer/sharer.php?u=' +
                                encodeURIComponent(shareLink) +
                                '&description=' +
                                encodeURIComponent(shareDesc) +
                                '&title=' +
                                encodeURIComponent(shareTitle) +
                                '&display=popup&ref=plugin&src=share_button',
                            'facebook',
                            'height=500, width=750, top=' +
                                (document.body.clientHeight / 2 - 250) +
                                ', left=' +
                                (document.body.offsetWidth / 2 - 375) +
                                ', toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no'
                        );
                        break;
                    case 'vk':
                        window.open(
                            `http://vk.com/share.php?url=${encodeURIComponent(
                                shareLink
                            )}&title=${shareTitle}&description=${shareDesc}&image=${encodeURIComponent(
                                shareImg
                            )}`
                        );
                        break;
                    case 'wp':
                        let content = '';
                        content += shareTitle;
                        content += shareDesc;
                        content += '\n' + shareLink + '\n';
                        location =
                            'whatsapp://send?text=' +
                            encodeURIComponent(content);
                        break;
                }
            }
        }
    },
    watch: {
        popShow: {
            handler(val) {
                if (val) {
                    setTimeout(() => {
                        this.fadeIn = true;
                    }, 100);
                } else {
                    this.fadeIn = false;
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.popup-share-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    z-index: 99;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;

    &.fadeIn {
        opacity: 1;
    }

    .popup-share {
        width: 100%;
        height: 438px;
        position: absolute;
        bottom: 0;
        background: url(~@/assets/img/share_bg.png) center/cover no-repeat;
        padding-top: 30px;
        box-sizing: border-box;
        transform: translate3d(0, 440px, 0);
        transition: transform 0.2s ease-in-out;

        &.fadeIn {
            transform: translate3d(0, 0, 0);
        }

        p {
            font-size: 32px;
            color: #3f4441;
            text-align: center;
        }

        .sns-list {
            width: 484px;
            margin: 48px auto 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .sns-btn {
                width: 116px;
                height: 122px;

                &:active {
                    transform: scale(0.96);
                }

                &.sns-fb {
                    background: url(~@/assets/img/btn_fb.png) top center/100%
                        100% no-repeat;
                }

                &.sns-vk {
                    background: url(~@/assets/img/btn_vk.png) top center/100%
                        100% no-repeat;
                }

                &.sns-wp {
                    background: url(~@/assets/img/btn_wp.png) top center/100%
                        100% no-repeat;
                }
            }
        }

        .btn-cancel {
            width: 483px;
            height: 88px;
            padding-top: 24px;
            box-sizing: border-box;
            // line-height: 88px;
            font-size: 32px;
            color: #b0b6b3;
            background: url(~@/assets/img/btn_cancel_share.png) center/100% 100%
                no-repeat;
            margin: 0 auto;
            text-align: center;
            user-select: none;

            &:active {
                padding-top: 28px;
                transform: scale(0.96);
            }
        }
    }
}
</style>
